import { inject, Injectable } from '@angular/core';
import {
  LOGIN_PICKER_IN_RESHOP_CONFIRMATION,
  LOGIN_PICKER_RESTRCITED_PAGE_LIST
} from '../login-modal/constants/login-constant';
import { CoreUtilService } from './core-util.service';
import { LoginHelperUtils } from './login-helper.utils';

@Injectable({
  providedIn: 'root'
})
export class LoginAuthenticationSupportService {
  coreUtilService = inject(CoreUtilService);
  loginHelperUtils = inject(LoginHelperUtils);

  checkForLoginPickerRestrictedPageList(standalone?: boolean): boolean {
    const { currentPage, decodeURL, fromAdmin } =
      this.loginHelperUtils.getRefreshURLParams();
    let restrictedPage = false;

    LOGIN_PICKER_RESTRCITED_PAGE_LIST.forEach((url) => {
      if (this.isRestricted(standalone, decodeURL, url, fromAdmin)) {
        if (fromAdmin) {
          this.loginHelperUtils.fromAdmin$.next(fromAdmin);
          restrictedPage = true;
        }
        restrictedPage = true;
      } else if (currentPage.includes(url)) {
        restrictedPage = true;
      }
    });
    LOGIN_PICKER_IN_RESHOP_CONFIRMATION.forEach((url) => {
      if (currentPage.includes(url)) {
        restrictedPage = false;
      }
    });
    return restrictedPage;
  }

  isRestricted(
    standalone: boolean | undefined,
    decodeURL: string,
    url: string,
    fromAdmin: boolean
  ) {
    return (
      (standalone && decodeURL?.includes(url)) || (standalone && fromAdmin)
    );
  }
}
